export function activeSizeBands(rows, type) {
    return rows.filter((row) => row.Active && row.doorType === type);
}
export function sizeBandContains(band, size) {
    return (size.width >= band.minDoorWidth &&
        size.width <= band.maxDoorWidth &&
        size.height >= band.minDoorHeight &&
        size.height <= band.maxDoorHeight);
}
export function sizeBandEnvelope(rows) {
    if (rows.length === 0) {
        return undefined;
    }
    return {
        minWidth: Math.min(...rows.map((row) => row.minDoorWidth)),
        maxWidth: Math.max(...rows.map((row) => row.maxDoorWidth)),
        minHeight: Math.min(...rows.map((row) => row.minDoorHeight)),
        maxHeight: Math.max(...rows.map((row) => row.maxDoorHeight)),
    };
}
export function findSizeAvailability(rows, type, size) {
    if (!Number.isSafeInteger(size.width) || !Number.isSafeInteger(size.height)) {
        return { status: 'invalid' };
    }
    const active = activeSizeBands(rows, type);
    const limits = sizeBandEnvelope(active);
    if (!limits) {
        return { status: 'empty' };
    }
    if (active.some((band) => sizeBandContains(band, size))) {
        return { status: 'available', limits };
    }
    const outside = size.width < limits.minWidth ||
        size.width > limits.maxWidth ||
        size.height < limits.minHeight ||
        size.height > limits.maxHeight;
    return { status: outside ? 'outside-range' : 'gap', limits };
}
//# sourceMappingURL=catalogue.js.map